export const filterByAlphabetical = (tabTechno) => {
  if (!Array.isArray(tabTechno)) {
    return tabTechno;
  }
  return tabTechno.sort((a, b) => a.name.localeCompare(b.name));
};
